<!-- 负面清单页 -->
<template>
    <div class="v-negative">
        <div class="negative-header">
            <v-header ref="vHeader" :isShowSearch="IsShowSearch" @buildAccrualListReq="buildAccrualListReq"></v-header>
        </div>
        <div class="negative-content">
            <div class="negative-nav">
                <div class="nav-lv1">
                    <div class="nav-title">一级类别：</div>
                    <div class="nav-content">
                        <span class="nav-lv1-item"
                            :class="[{'nav-lv1-border': index != (Lv1List.length - 1)}, {'nav-item-active': SelectLv1 == item.yjlb}]"
                            v-for="(item, index) in Lv1List" @click="selectLv1Item(item)">{{ item.yjlb }}</span>
                    </div>
                </div>
                <div class="nav-lv2">
                    <div class="nav-title">二级类别：</div>
                    <Row>
                        <Col span="5" v-for="(item, index) in Lv2List" :key="index">
                        <div class="nav-content">
                            <span class="nav-lv2-item" :class="SelectLv2 == item.ejlb ? 'nav-item-active' : ''"
                                @click="selectLv2Item(item)">{{ item.ejlb }}</span>
                        </div>
                        </Col>
                    </Row>
                </div>
            </div>
            <div class="negative-table">
                <table border="0" cellpadding="0" cellspacing="0">
                    <tr>
                        <th style="width: 6%;">序号</th>
                        <th style="width: 14%;">类别</th>
                        <th style="width: 50%;">具体描述或情形</th>
                        <th style="width: 30%;">设定依据</th>
                    </tr>
                    <template v-for="(item, index) in NegativeList">
                        <tr v-for="(citem, i) in item.children">
                            <td>{{ citem.num }}</td>
                            <!-- 第二列的类别只需要1个td 然后rowspan子集的长度 -->
                            <td v-if="i == 0" :rowspan="item.children.length">
                                {{item.sjlb}}
                            </td>
                            <td style="text-align: left;">{{ citem.detail }}</td>
                            <td style="text-align: left;">{{ citem.ssyj }}</td>
                        </tr>
                    </template>
                    <tr v-if="NegativeList.length == 0">
                        <td colspan="4">暂无数据</td>
                    </tr>
                </table>
            </div>
        </div>
        <BackTop :height="backTopHei" :duration="backTopDur" class="btn-backtop">
            <div class="btn-backtop-icon"></div>
        </BackTop>
        <div class="negative-footer">
            <div class="negative-introduce">
                <a href="javascript:void(0);">北大法宝权责清单智能管理系统简介</a>
            </div>
            <div class="negative-copyright">
                <div class="copyright-item">
                    <a href="https://pkulaw.com/helps/58.html" target="_blank">英华介绍</a>
                    <span>::</span>
                    <a href="http://www.pkulaw.cn/help/index.html?item=FBKH" target="_blank">经典客户</a>

                    <span>::</span>
                    <a href="https://pkulaw.com/help/more-service-law-notice.html" target="_blank">法律声明</a>
                    <span>::</span>
                    <a href="http://www.pkulaw.cn/css/websit_map.htm" target="_blank">网站地图</a>
                    <span>::</span>

                    <a href="mailto:info@chinalawinfo.com">企业邮箱</a>
                </div>
                <p>版权所有 ：北京北大英华科技有限公司 北京大学法制信息中心 <a href="http://www.beian.miit.gov.cn/"
                        target="_blank">京ICP证010230-17号</a></p>
                <div class="copyright-logo">
                    <a href="http://www.pkulaw.cn/help/ad/20140818/index.html" rel="nofollow" target="_blank">
                        <img src="https://pkulaw.com/content/images/bdfb.jpg" alt="">
                    </a>
                    <a href="https://ss.knet.cn/verifyseal.dll?sn=e13042211010040250ewgy000000&amp;ct=df&amp;a=1&amp;pa=0.3386153630929789"
                        rel="nofollow" target="_blank"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VHeader from '@/views/header/VHeader.vue'
    import { reqNegativeDicData, reqNegativeListData } from "@/api/index";

    export default {
        name: 'VNegative',
        components: {
            VHeader
        },
        props: {
            // 小驼峰命名
            demoInfo: {
                type: String,
                default() {
                    return 'negative-demo'
                }
            }
        },
        data() {
            return {
                IsShowSearch: '4',
                BaseDict: [],
                Lv1List: [],
                Lv2List: [],
                SelectLv1: '',
                SelectLv2: '',
                SearchKey: '',
                NegativeList: [],
                // 返回顶部临界值
                backTopHei: 10,
                // 返回顶部动画时长
                backTopDur: 600,
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {
            this.getNegativeDicData();
        },
        destroyed() {

        },
        methods: {
            // 获取负面清单1 2级类别字典表
            getNegativeDicData() {
                reqNegativeDicData({}).then(res => {
                    this.BaseDict = res.data;
                    this.Lv1List = this.uniqueByKey(res.data);
                    this.Lv2List = res.data;
                    this.SelectLv1 = this.Lv1List[0].yjlb;
                    this.SelectLv2 = this.Lv2List[0].ejlb;
                    this.getNegativeListData();
                });
            },

            // 获取负面清单数据
            getNegativeListData() {
                let postData = {
                    keyword: this.SearchKey,
                    yjlb: this.SelectLv1,
                    ejlb: this.SelectLv2,
                    pageSize: 500,
                    pageNum: 1
                }
                reqNegativeListData(postData).then(res => {
                    let filterData = this.uniqueByKey(res.data.data, 'sjlb');
                    let result = [];
                    let num = 1;

                    filterData.forEach(item => {
                        let tempObj = {
                            sjlb: '',
                            children: []
                        }
                        res.data.data.forEach(ele => {
                            if (item.sjlb == ele.sjlb) {
                                ele.num = num++;
                                tempObj.sjlb = ele.sjlb;
                                tempObj.children.push(ele)
                            }
                        });
                        result.push(tempObj);
                    });
                    this.NegativeList = result;
                    console.log(this.NegativeList)
                });
            },

            selectLv1Item(item) {
                this.SelectLv1 = item.yjlb;
                this.Lv2List = this.filterLv2Dict(this.SelectLv1);
                this.SelectLv2 = this.Lv2List[0].ejlb;
                this.getNegativeListData();
            },

            selectLv2Item(item) {
                this.SelectLv2 = item.ejlb;
                this.getNegativeListData();
            },

            // 请求参数,拼接权责列表请求参数
            buildAccrualListReq(params, flag, zqlyParams) {
                this.SearchKey = params.keyword;
                this.getNegativeListData();
            },

            // json数组去重
            uniqueByKey(arr, key) {
                let hash = {};
                let result = arr.reduce((total, currentValue) => {
                    if (!hash[currentValue[key]]) { //如果当前元素的key值没有在hash对象里，则可放入最终结果数组
                        hash[currentValue[key]] = true; //把当前元素key值添加到hash对象
                        total.push(currentValue); //把当前元素放入结果数组
                    }
                    return total; //返回结果数组
                }, []);
                return result;
            },

            // 1 2级类别联动
            filterLv2Dict(key) {
                let result = [];
                this.BaseDict.forEach(item => {
                    if (item.yjlb == key) {
                        result.push(item)
                    }
                });
                return result;
            }
        },
        filter: {

        }
    }
</script>

<style scoped>
    .v-negative {
        min-height: 100%;
        background-color: #f7f8f8;
    }

    .negative-header {
        background-color: #fff;
    }

    .negative-content {
        overflow: hidden;
        padding: 0 20px;
        margin: 0 auto;
        width: 1200px;
        min-height: 547px;
    }

    .negative-footer {
        padding: 0 20px;
        color: #fff;
        background-color: #17181e;
    }

    .negative-introduce {
        padding: 20px;
        text-align: center;
        border-bottom: 1px solid #394c5e;
    }

    .negative-introduce a {
        font-size: 24px;
        color: #fff;
    }

    .negative-copyright {
        position: relative;
        padding: 20px;
        text-align: center;
    }

    .negative-copyright a {
        color: #fff;
    }

    .copyright-item {
        margin-bottom: 10px;
    }

    .copyright-logo {
        position: absolute;
        top: 24px;
        right: 60px;
    }

    .negative-nav {
        overflow: hidden;
        margin: 20px 0;
        border: 1px solid #e0e8f7;
        border-radius: 3px;

    }

    .nav-lv1 {
        display: flex;
        border-bottom: 1px solid #e0e8f7;
    }

    .nav-lv2 {
        display: flex;
    }

    .nav-title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 16px;
        width: 18%;
        font-size: 14px;
        font-weight: bolder;
        text-align: center;
        color: #2d4060;
        background-color: #f7f8fc;
    }

    .nav-lv1 .nav-content {
        display: flex;
        align-items: center;
        padding: 16px 24px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #2d4060;
        background-color: #fff;
    }

    .nav-lv1-item {
        margin-right: 20px;
        padding-right: 25px;
        cursor: pointer;
    }

    .nav-lv1-border {
        border-right: 1px solid #a8a8a8;
    }

    .nav-lv2 .nav-content {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #585f62;
        background-color: #fff;
    }

    .nav-lv2 .ivu-row {
        padding: 16px;
        width: 100%;
        background-color: #fff;
    }

    .nav-lv2-item {
        padding: 8px 10px;
        border: 1px solid #e0e8f7;
        border-radius: 3px;
        width: 100%;
    }

    .nav-lv1 .nav-content span:hover {
        color: #2d4060;
        cursor: pointer;
    }

    .nav-lv2 .nav-content span:hover {
        border: 1px solid #e0e8f7;
        color: #2d4060;
        background-color: #f7f8fc;
        cursor: pointer;
    }

    .nav-lv1 .nav-item-active {
        color: #2d4060;
    }

    .nav-lv2 .nav-item-active {
        border: 1px solid #e0e8f7;
        color: #2d4060;
        background-color: #f7f8fc;
    }

    .nav-lv2 .ivu-col-span-5 {
        width: 20%;
    }

    .negative-table {
        margin-bottom: 20px;
    }

    .negative-table table {
        border-top: 1px solid #e0e8f7;
        border-left: 1px solid #e0e8f7;
        width: 100%;
        text-align: center;
    }

    .negative-table th {
        padding: 20px 0;
        border-right: 1px solid #e0e8f7;
        border-bottom: 1px solid #e0e8f7;
        font-size: 14px;
        font-weight: bolder;
        color: #2d4060;
        background-color: #f7f8fc;
    }

    .negative-table td {
        padding: 20px 8px;
        border-right: 1px solid #e0e8f7;
        border-bottom: 1px solid #e0e8f7;
        font-size: 14px;
        color: #2d4060;
        background-color: #fff;
    }

    .btn-backtop-icon {
        width: 44px;
        height: 48px;
        background: url(../assets/backtop.png) 0 0 no-repeat;
    }
</style>